<div  style="position: relative;">
    <h1>Get the Embed Code for Your Website</h1>
    <button (click)="copyCode()" class="fs-10 fw-4" style="background-color: transparent;color:gray; border:none; position: absolute; right:25px; top:25px">Copy Code</button>
    <div id="codeBlock">
        <code>
            &lt;iframe src="https://app.zeatool.com/#/provider-detail/{{code}}" style="width: 100%;height: 100%;" frameborder="0"&gt;&lt;/iframe&gt;
        </code>
    </div>
</div>
